import ACTION_SET_UTIL_DEFAULT_TZ from '@/app/module/utils/definitions'

export default function setDefaultTimezone(tz) {
  return {
    type: ACTION_SET_UTIL_DEFAULT_TZ,
    value: tz,
  }
}
